import { apiClient } from "@/lib/api/client";
import type { DeviceChannelCreateDto, DeviceChannelDto } from "@/lib/api/types";

export type ListDeviceChannelsParams = {
  workspaceScope?: "all" | null;
};

export async function listDeviceChannels(
  deviceId: string,
  params?: ListDeviceChannelsParams,
): Promise<DeviceChannelDto[]> {
  const { data } = await apiClient.get<DeviceChannelDto[]>(`/devices/${deviceId}/channels`, {
    __skipTenantHeader: params?.workspaceScope === "all",
  });
  return data;
}

export async function createDeviceChannel(
  deviceId: string,
  body: DeviceChannelCreateDto,
): Promise<DeviceChannelDto> {
  const { data } = await apiClient.post<DeviceChannelDto>(`/devices/${deviceId}/channels`, body);
  return data;
}

export async function updateDeviceChannel(
  channelId: string,
  body: Partial<DeviceChannelDto>,
): Promise<DeviceChannelDto> {
  const { data } = await apiClient.put<DeviceChannelDto>(`/channels/${channelId}`, body);
  return data;
}

export async function deleteDeviceChannel(channelId: string): Promise<void> {
  await apiClient.delete(`/channels/${channelId}`);
}
